import { MoveIcon } from '@ui/kit/icons';
import { moveIcon } from './atom.move-icon.style.js';
import { jsx } from 'react/jsx-runtime';

function TileMoveIcon(props) {
  if (props.state !== "input" || !props.isDraggable) {
    return null;
  }
  return /*#__PURE__*/jsx("span", {
    className: moveIcon,
    children: /*#__PURE__*/jsx(MoveIcon, {
      height: 13,
      vectorEffect: null
    })
  });
}

export { TileMoveIcon };
//# sourceMappingURL=atom.move-icon.js.map
